import { render, staticRenderFns } from "./TheHomeWeddingsItem.vue?vue&type=template&id=c6bc7a8e"
import script from "./TheHomeWeddingsItem.vue?vue&type=script&lang=js"
export * from "./TheHomeWeddingsItem.vue?vue&type=script&lang=js"
import style0 from "./TheHomeWeddingsItem.vue?vue&type=style&index=0&id=c6bc7a8e&prod&scopes=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports